module.exports = __webpack_public_path__ + "static/media/p3s.e0a8fca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p3s.png
// module id = 269
// module chunks = 0